import type { SxProps } from '@mui/material/styles';

export const commonListSx: SxProps = {
  width: '100%',
  px: 4,
  '& .RaList-main': {
    width: '100%',
  },
  '& .RaDatagrid-headerCell': {
    whiteSpace: 'nowrap',
  },
  '& .RaDatagrid-tableWrapper': {
    marginTop: 3,
  },
};
